import { GetStaticProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SSRConfig } from 'next-i18next';
import get from 'lodash/get';
import SignUpCard from '../../components/account/SignUpCard';
import BaseAccountPage from '../../components/account/BaseAccountPage';
import { requestWithCache } from '../../core/request';
import type FooterType from '../../../types/Footer';
import translator from '../../core/helpers/translator';
import { generateLinks } from '../../core/helpers/link';
import { Locale } from '../../core/constants';

interface Props {
  footer?: FooterType;
}

const SignUp: NextPage<Props> = ({ footer }) => {
  return (
    <BaseAccountPage footer={footer}>
      <SignUpCard />
    </BaseAccountPage>
  );
};

export const getStaticProps: GetStaticProps<SSRConfig> = async ({ locale }) => {
  const footer = await requestWithCache<FooterType>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/footer?locale=${translator.locale.get(locale)}`,
    method: 'GET',
  });

  const url = new URL(`${process.env.NEXT_PUBLIC_SITE_URL}/account/signup`);

  const ssrConfig = await serverSideTranslations(translator.locale.get(locale), [
    'component',
    'common',
    'page',
    'error',
  ]);

  const namespaces =
    // eslint-disable-next-line no-underscore-dangle
    locale && ssrConfig._nextI18Next.initialI18nStore[translator.locale.get(locale)];

  const translationTargets = {
    title: get(namespaces.page, 'sign_up.title', null),
  };

  const translatedMetadata = await translator.batch.translate(translationTargets, locale);

  const metadata = {
    title: translatedMetadata.title,
    'og:title': translatedMetadata.title,
    'og:url': `${url.origin}${locale !== Locale.JAPANESE ? `/${locale}` : ''}${url.pathname}`,
  };
  return {
    props: {
      ...ssrConfig,
      footer,
      links: generateLinks(url),
      metadata,
    },
  };
};

export default SignUp;
